import styled from "styled-components";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";

type ContainerHeaderType = {
    bordercolor: string;
    background: string;
}

type ContainerSuccessExportType = {
    bordercolor: string;
}

type TextType = {
    color: string;
}

type IconType = {
    color: string;
    size: number;
}

type ContentEditType = {
    canChange: boolean;
    color: string;
}

type LineClampType = {
    width: number;
    toShare?: boolean;
}

type ContainerButtonDeleteExportType = {
    background: string;
    accent: string;
    bordercolor: string;
};

export const Container = styled.div<ContainerHeaderType>`
    padding: 0 16px;
    justify-content: flex-start;
    align-items: center;
    display: flex;
    width: 100%;
    background: ${(props) => props.background};
`;

export const TextExportation = styled.span<TextType>`
    font-size: 12px;
    color: ${(props) => props.color};
    margin-right: 10px;
`;

export const TextDownloadExport = styled.span<TextType>`
    font-size: 12px;
    color: ${(props) => props.color};
    margin-right: 10px;
    text-decoration: underline;
    cursor: pointer;
    width: fit-content;
`;
export const ContentProtocol = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
`;
export const Separator = styled.div`
    display: flex;
    width: 25px;
    min-width: 25px;
    align-items: center;
    justify-content: center;
`;

export const ContentButtonExportation = styled.div`
    display: flex;
`;
export const ContentExportation = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 65px;
    flex-direction: column;
    padding: 0 0 5px 0;
`;

export const TextProtocol = styled.span<TextType>`
    font-size: 15px;
    color: ${props => props.color};
`;
export const ContainerDescription = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;
export const ContentDescriptionProblem = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 48px;
    max-height: 48px;
    padding: 0 10px;
    justify-content: space-between;
`;
export const ContentClientData = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    min-height: 20px;
    max-height: 20px;
`;

export const ContentDataTicket = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const IconEdit = styled.i<IconType>`
    font-size: ${props => props.size}px;
    color: ${props => props.color};
    cursor: pointer;
    display: none;
    pointer-events: none;
    margin-left: 3px;
`;


export const ContentEdit = styled.div<ContentEditType>`
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 20px;
    max-height: 20px;
    width: fit-content;

    &:hover ${IconEdit} {
        display: ${(props) => props.canChange ? 'inline' : 'none'};
    }

    &:hover {
        text-decoration: ${(props) => props.canChange ? 'underline' : 'auto'};
        text-decoration-color: ${props => props.color};
        cursor: ${(props) => props.canChange ? 'pointer' : 'auto'};
    }
`;

export const ContentSector = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 20px;
    max-height: 20px;
    width: fit-content;
`;
export const ContentLineClamp = styled.div<LineClampType>`
    display: block;
    max-width: calc((100vw - ${props => `${props.width}px`}) / ${props => props.toShare ? 2 : 1}) !important;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    white-space: nowrap;
`;

export const ContentDateHour = styled.div`
    display: flex;
    flex-direction: row;
`;


export const TextDescriptionProblem = styled.span<TextType>`
    font-size: 15px;
    color: ${props => props.color};
    text-align: left;
`;

export const TextClient = styled.span<TextType>`
    font-size: 15px;
    color: ${props => props.color};
    text-align: left;
`;

export const ContentProgress = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-left: 15px;
    min-height: 55px;
`;

export const ContainerSuccessExport = styled.div<ContainerSuccessExportType>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border: 1px solid ${props => props.bordercolor};
    border-radius: 12px;
    max-height: 55px;
`;

export const ContentExportDetails = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ContentDeleteExport = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ContainerButtonDeleteExport = styled.div<ContainerButtonDeleteExportType>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 25px;
    min-width: 25px;
    max-width: 25px;
    height: 25px;
    min-height: 25px;
    max-height: 25px;
    border-radius: 50%;
    cursor: pointer;
    background: ${props => props.background};
    border: 1px solid ${props => props.bordercolor};
    &:hover {
       
        border-color: transparent;
        box-shadow: 0 0 0 2px ${props => hexToRGBA(props.accent, .58)};
        outline: none;
        transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
    }
`;